import { generatePath, Redirect, Route } from 'react-router-dom'
import { isAtLeastOneAccessFlagEnabled } from 'app/navigation/helpers'
import { accountsTokensPaths } from 'app/navigation/paths'
import { accountSettingsSubroutes } from 'app/navigation/staticSubRoutes.accountSettings'
import CustomSwitch from 'app/router/Switch'
import { useFlags } from 'launchdarkly-react-client-sdk'

import Footer from 'common/components/layout/Footer'
import PageContainer from 'common/components/PageContainer'
import { useDocumentTitle } from 'common/hooks/custom'
import { useAppSelector } from 'common/hooks/redux'

import AccountSettingsNavBar from './AccountSettingsNavBar'

const AccountSettings = () => {
  useDocumentTitle('Account settings | Phrasee')

  const flags = useFlags()

  const accountId = useAppSelector((state) => state.authStates.accountId)
  const routes = accountSettingsSubroutes
    .filter(({ accessFlags }) =>
      isAtLeastOneAccessFlagEnabled(flags, accessFlags?.flags)
    )
    .map((route) => {
      return { ...route, to: generatePath(route.to, { accountId }) }
    })

  return (
    <PageContainer>
      <AccountSettingsNavBar subroutes={routes} title="Account settings" />
      <CustomSwitch>
        {routes.map(({ key, to, component: Component }) => (
          <Route key={key} path={to}>
            <Component />
          </Route>
        ))}
        {/* fix redirecting to revenue tab on account id change */}
        <Redirect
          exact
          from={accountsTokensPaths}
          to={generatePath(accountsTokensPaths, { accountId })}
        />
        <Redirect from="/admin/accounts/:accountId?" to={routes[0].to} />
      </CustomSwitch>

      <Footer />
    </PageContainer>
  )
}

export default AccountSettings
